<template>
    <div class="data page">
        <main>
            <form @submit.prevent="nextStep">
                <div class="container-fluid">
                    <div class="row pb-24">
                        <div class="col-12 col-lg-6 offset-lg-3">

                            <router-link :to="{name: 'step1' }" class="previous-step">
                                <span>Mijn gegevens</span>
                                <span>Stap 1 van 3</span>
                            </router-link>

                            <div class="step pt-24 ">
                                <div class="d-flex justify-content-between">
                                    <h1 class="h1">Mijn woonsituatie</h1>
                                    <h2 class="h1">Stap 2 van 3</h2>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Gezinssamenstelling</h3>
                                    <div class="form-row">
                                        <div class="form-field w-50">
                                            <select  v-model="data.number_adults" required>
                                                <option :value="undefined" disabled selected>Aantal volwassenen</option>
                                                <option>1</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                                <option>5</option>
                                            </select>
                                        </div>
                                        <div class="form-field w-50">
                                            <select v-model="data.number_children" required>
                                                <option :value="undefined" disabled selected>Aantal kinderen</option>
                                                <option>0</option>
                                                <option>1</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                                <option>5</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Uw woonsituatie</h3>
                                    <div class="form-row">
                                        <div class="form-field w-100">
                                            <select  v-model="data.residence_type" required>
                                                <option :value="undefined" disabled selected>Huidige woningtype</option>
                                                <option value="koopwoning">Koopwoning</option>
                                                <option value="huurwoning">Huurwoning</option>
                                                <option value="inwonend">Inwonend</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
<!--                        <div class="col-3 pt-24  d-none d-lg-block">-->
<!--                            <div class="h-100 d-flex justify-content-end">-->
<!--                                <div class="tooltip-wrap">-->
<!--                                    <a class="tooltip-btn">Info</a>-->
<!--                                    <div class="tooltip-content">-->
<!--                                        Tooltip over twee regels.-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-6">
                            <div class="step__footer text-right">
                                <button class="btn btn-primary">Volgende</button>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </main>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data: {},
            }
        },
        mounted(){
            if(Object.keys(this.$store.state.form).length > 0){
                this.data = this.$store.state.form
            } else {
                this.prefill()
            }
        },
        methods: {
            nextStep () {
                this.$store.commit('saveStep', this.data)
                this.$router.push({name: 'step3' })
            },
            prefill () {
                if(!this.$user){
                    return
                }
                let user = this.$user

                // set user data
                Object.entries(user).forEach((row) => {
                    let name = row[0]
                    let value = row[1]
                    if(value && typeof value !== 'object'){
                        if(!this.data[name]) {
                            this.$set(this.data, name, value)
                        }
                    }
                })
            }
        }
    }
</script>


